const ConfigActionTypes = {
  FETCH_CONFIG_START: 'FETCH_CONFIG_START',
  FETCH_CONFIG_SUCCESS: 'FETCH_CONFIG_SUCCESS',
  FETCH_CONFIG_FAILURE: 'FETCH_CATALOG_FAILURE',
  SET_IS_GOOGLE_MAPS_LOADED: 'SET_IS_GOOGLE_MAPS_LOADED',
};

export default ConfigActionTypes;
